<h5>Sms Credits</h5>
<form [formGroup]="form" (submit)="onSubmit($event)" class="row no-gutters">
  <div class="col form-group current-credits">
    <label class="form-control-label text-nowrap">
      <strong>Current credits</strong>
    </label>
    <div class="current-credits-value">
      <span>{{ currentSmsCredits?.credits | credit }}</span>
    </div>
  </div>

  <div class="col form-group">
    <div>
      <label class="form-control-label text-nowrap" for="sms-credits">
        Top up with credits *
      </label>
      <input
        [appNumericInput]="{ allowedChars: '-' }"
        class="form-control"
        id="sms-credits"
        placeholder="Sms credits"
        [formControl]="smsCredits"
      />
      <div
        class="form-control-feedback text-danger"
        *ngIf="smsCredits.invalid && (smsCredits.dirty || smsCredits.touched)"
      >
        <span *ngIf="smsCredits.hasError('required')">Required</span>
      </div>
    </div>
  </div>
  <div class="col form-group">
    <div>
      <label class="form-control-label text-nowrap" for="order-id">
        Order number *
      </label>
      <input
        type="text"
        class="form-control"
        placeholder="Order number (16 alphanumeric characters)"
        id="order-id"
        maxLength="17"
        [formControl]="orderId"
      />
      <div
        class="form-control-feedback text-danger"
        *ngIf="orderId.invalid && (orderId.dirty || orderId.touched)"
      >
        <span *ngIf="orderId.hasError('required')">Required</span>
        <span *ngIf="orderId.hasError('pattern')">
          Order number is invalid. It should have 16 alphanumeric characters
        </span>
      </div>
    </div>
  </div>
  <div class="col">
    <app-button
      bsClass="primary"
      buttonType="submit"
      [disabled]="disabledSubmit"
      [tooltip]="
        !canPlaceOrders
          ? 'You have to be an order manager to update SMS credits'
          : ''
      "
      [labeled]="true"
      [showLoader]="isUpdatingSmsCredits"
    >
      Add Credits
    </app-button>
  </div>
</form>
